import { Component, OnInit, Optional } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TimezoneAppItemOutputDto } from '@shared/api/model/timezone-app-item-output-dto';
import { CoreFacade } from 'app/core/core.facade';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Select } from 'primeng/select';
import { firstValueFrom } from 'rxjs';
import { LoaderComponent } from "@shared/components/loader/loader.component";
import { DataTestIdPipe } from '../../../../shared/pipes/data-test-id.pipe';

@Component({
  selector: 'app-timezone',
  imports: [Select, ButtonModule, FormsModule, LoaderComponent, DataTestIdPipe],
  templateUrl: './timezone.component.html',
  styles: ``
})
export class TimezoneComponent implements OnInit {

  selectedTimezone?: TimezoneAppItemOutputDto;

  timezoneList: TimezoneAppItemOutputDto[] = [];

  loading = false;

  constructor(private facade: CoreFacade,
            @Optional() private dialogRef: DynamicDialogRef,
            @Optional() private dynamicDialogConfig: DynamicDialogConfig) {
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;

    // load timezones from state
    const appTimezones = await firstValueFrom(this.facade.timezonesList$) || [];
    // use only time zones supported by intl
    this.timezoneList = appTimezones.filter(z => this.facade.isIanaIdIntlSupportedTimeZone(z.ianaId!)).slice();

    if (this.dynamicDialogConfig && this.dynamicDialogConfig.data.timezone?.ianaId) {
      this.selectedTimezone = this.timezoneList.find(t => t.ianaId === this.dynamicDialogConfig.data.timezone.ianaId);
    }

    this.loading = false;
  }

  save() {
    this.facade.setTimezone(this.selectedTimezone!);
    this.dialogRef.close(true);
  }

}
